import { render } from "./ModalNewGame.vue?vue&type=template&id=3e7f0067"
import script from "./ModalNewGame.vue?vue&type=script&lang=js"
export * from "./ModalNewGame.vue?vue&type=script&lang=js"
script.render = render

export default script